import { useEffect } from 'react'
import { Spinner } from '../icons'
import useTitle from '../../hooks/use-title'

function FullPageLoading ({ title = 'Loading...' }) {
  useTitle(title)
  useEffect(() => {
    document.body.classList.add('bg-dark')
  })
  return (
    <div className='p-4 text-white'>
      Loading...
    </div>
  )
}

function LoadingSpinner ({ show = true, className = '', spinnerClassName = 'h-5 w-5' }) {
  if (!show) {
    return null
  }

  return (
    <i className={`inline-block text-purple-50 ${className}`}>
      <Spinner className={spinnerClassName} />
    </i>
  )
}

export {
  LoadingSpinner,
  FullPageLoading
}
